import { makeRequest } from 'utils/requestLogger';

export default (submissionID) =>
    makeRequest('put', `/api/submissions/${submissionID}/opened`);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/openSubmission.js